import axios from 'axios';

const analyticsClient = axios.create({
    // baseURL: process.env.REACT_APP_ANALYTICS_BASE_URL,
    baseURL: 'https://api.analytics.stylelink.in',
    timeout: 30000,
});

const stored = localStorage.getItem('userIdentifier');
if (stored) analyticsClient.defaults.headers.common['x-analytics-secret'] = stored;

export function setAnalyticsSecret(secret) {
    console.log('[Analytics] setAnalyticsSecret called with:', secret);
    analyticsClient.defaults.headers.common['x-analytics-secret'] = secret;
}

analyticsClient.interceptors.response.use(
    (res) => res.data,
    (err) => {
        const msg = err?.response?.data?.error || 'Analytics API error';
        console.error('[Analytics]', msg);
        return Promise.reject(new Error(msg));
    },
);

export default analyticsClient;

export function defaultDateRange() {
    const to = new Date().toISOString().slice(0, 10);
    const from = new Date(Date.now() - 30 * 86400000).toISOString().slice(0, 10);
    return { from, to };
}

export async function fetchAnalytics(endpoint, params) {
    try {
        const response = await analyticsClient.get(endpoint, { params });
        return { data: response.data, error: null };
    } catch (err) {
        return { data: null, error: err.message };
    }
}
